const BASE_TRADE_RECEIPT_LOCATORS = "TradeReceiptLocators"

export const TRADE_RECEIPT_LOCATORS = {
  displayName: `${BASE_TRADE_RECEIPT_LOCATORS}.displayName`,
  logo: `${BASE_TRADE_RECEIPT_LOCATORS}.logo`,
  closeButton: `${BASE_TRADE_RECEIPT_LOCATORS}.closeButton`,
}
